/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (form-field layout wrapper: label column + text column)
 *   extends:   Component (@glimmer/component)
 *   template:  bb-field.hbs
 *   args:      @classLabel, @classText
 *   uses:      -
 *   siblings:  -
 *   tests:     ui-components-test.js, template-components-test.js
 *
 * Presentational wrapper providing default Foundation grid classes for a
 * label/value pair, overridable via @classLabel / @classText.
 */
import Component from '@glimmer/component';

export default class BbFieldComponent extends Component {
  get classLabel() {
    return this.args.classLabel || 'cell small-12 medium-3';
  }

  get classText() {
    return this.args.classText || 'cell small-12 medium-9';
  }
}
